var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "sidebar", attrs: { id: "sidebar" } }, [
      _c("div", { staticClass: "sidebar-inner v-slimscroll" }, [
        _c("div", { staticClass: "sidebar-menu" }, [
          _c("ul", [
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/index" } }, [
                  _c("i", { staticClass: "la la-home" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Back to Home")])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/#" } }, [
                  _vm._v("Project Management")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "tasks" },
              [
                _c("router-link", { attrs: { to: "/tasks" } }, [
                  _vm._v("Hospital Administration")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/#" } }, [
                  _vm._v("Video Calling App")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/#" } }, [
                  _vm._v("Office Management")
                ])
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "menu-title" }, [
      _vm._v("\n            Projects\n            "),
      _c(
        "a",
        {
          attrs: {
            href: "#",
            "data-toggle": "modal",
            "data-target": "#create_project"
          }
        },
        [_c("i", { staticClass: "fa fa-plus" })]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d511cb9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d511cb9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/SidebarReports.vue
// module id = null
// module chunks = 